// Smooth-scroll to an in-page anchor. Uses the Lenis instance when available
// (native window.scrollTo is overridden by Lenis, so it must be used), with a
// scrollIntoView fallback for safety.
export function scrollToId(target, offset = -72) {
  const el = typeof target === "string" ? document.querySelector(target) : target;
  if (!el) return;
  const lenis = window.__lenis;
  if (lenis && typeof lenis.scrollTo === "function") {
    lenis.scrollTo(el, { offset });
  } else {
    const top = el.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top, behavior: "smooth" });
  }
}
